/**
 * 採用エントリーのフォーム（/recruit/entry）のエントリポイント。
 * esbuild で public/js/entry.js に出力し、app/Views/recruit/entry/entry.twig が読み込む。
 */
import {EntryFormView} from "@mvvm/view/recruit/EntryFormView";
import {EntryFormViewModel} from "@mvvm/view_model/recruit/EntryFormViewModel";

async function main(): Promise<void> {
    const view = new EntryFormView();
    if (!await view.append()) {
        return;
    }

    await new EntryFormViewModel(view).mediate();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => void main());
} else {
    void main();
}

export {};
